import { Observable, Subscription, interval } from 'rxjs';
import { Router } from '@angular/router';
import { TrainService } from './../../service/train.service';
import { DBConnectorService } from './../../service/test.service';
import { SectorModel } from './../../service/sector.model';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoggedInGuard } from '../../authentication/logged-in.guard';
// import { DialogService } from 'ng2-bootstrap-modal';
import { ShowLogDialogComponent } from '../../show-log-dialog/show-log-dialog.component';
import { HttpClient } from '@angular/common/http';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

declare let d3: any;

const apiEndPoint = 'api/TrainNew/Step3NewData';

@Component({
  selector: 'app-step3newdata',
  templateUrl: './step3newdata.component.html',
  styleUrls: ['./step3newdata.component.css']
})
export class Step3newdataComponent implements OnInit, OnDestroy {
  bsModalRef: BsModalRef;
  sub: Subscription;
  Status: string;
  enableGetLogs: boolean;
  sectormodel = new SectorModel;
  result:any = {};
  click = true;
  options;
  data;
  months;
  total_records = 0;
  total_categories = 0;
  public result_data:any = {};
  urldata: any = {};
  accuracyOverviews;
  getcommandjson:any = {};

  constructor(private dbconnectorservice: DBConnectorService,
    private trainservice: TrainService,
    private http: HttpClient,
    private router: Router,
    private loggedInGuard: LoggedInGuard,
    private _dialogService: BsModalService
    ) {

    this.sectormodel.SectorName = this.dbconnectorservice.SectorName;
    this.sectormodel.ModelName = this.dbconnectorservice.ModelName;
    this.sectormodel.User = this.dbconnectorservice.username;
  }

  trainNew() {
    if (this.loggedInGuard.isSessionValid()) {
      this.enableGetLogs = true;
      this.click = false;
      console.log('Train - start');
      this.trainservice.TrainNew(this.sectormodel)
        .subscribe(
          (data) => {
            this.result = data;
            console.log(this.result);
            console.log('Train - after api');
            if (data['Train']) {
              this.router.navigate(['Train/Step3Done']);

            }
          });
    }
  }

  graphFunction() {
    this.http.get<any>(apiEndPoint + '?Sector=' + this.sectormodel.SectorName + '&Model=' + this.sectormodel.ModelName)      
      .subscribe((result) => {
        // console.log('home.component.ts: line 385: JSON.stringify(result) ' + JSON.stringify(result));
        this.urldata = result;
        // console.log('home.component.ts: line 385: JSON.stringify(this.urldata) ' + JSON.stringify(this.urldata));

        const slice_top_limit = 10;
        // console.log(result)
        this.accuracyOverviews = result['accuracyOverview']; // .slice(1, slice_top_limit);
        // console.log('home.component.ts: line 37 : accuracyOverviews ' + this.accuracyOverviews);
        const values1 = [];
        const values2 = [];
        for (const entry of this.accuracyOverviews) {

          this.total_categories += 1;
          const labelValue = {};
          labelValue['x'] = entry.category;
          labelValue['y'] = +entry.noOfRecords;
          this.total_records += +entry.noOfRecords;

          values1.push(labelValue);
        }

        const _array = [];
        const _dict = {};
        _dict['key'] = 'Total Records';
        _dict['color'] = 'grey';
        _dict['bar'] = true;
        _dict['values'] = values1;
        _array.push(_dict);

        this.data = _array;

        this.options = {
          'chart': {
            'type': 'multiBarChart',
            'height': 450,
            'margin': {
              'top': 40,
              'right': 20,
              'bottom': 100,
              'left': 45
            },
            'reduceXTicks': false,
            'showControls': false,
            'clipEdge': true,
            'duration': 500,
            'stacked': false,
            'xAxis': {
              // 'axisLabel': 'Category',
              'rotateLabels': -30,
              'showMaxMin': false,

            },
            'yAxis': {
              // 'axisLabel': 'Y Axis',
              'axisLabelDistance': -20
            }
          }
        };
      });
  }

  StatusCheck() {

    this.trainservice.statusCheck(this.sectormodel)
      .subscribe(
        (data) => {
          this.Status = data;
          if (this.Status === 'TRAINING') {
            this.click = false;
            this.enableGetLogs = true;
          } else if (this.Status === 'TRAINED' && this.click === false) {
            this.router.navigate(['Train/Step3Done']);
          } else {
            this.click = true;
          }
          console.log(this.Status);
        });

  }

  ngOnInit() {
    this.graphFunction();
    this.StatusCheck();

    this.sub = interval(5000).subscribe(x => {
      if (this.click === false) {
        this.StatusCheck();
      }

    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  OpenLogsTrainingNewDialog() {
    console.log("clicked!")
    const initialState = {
      source: "training",
      username: this.sectormodel.User
    };
    this.bsModalRef = this._dialogService.show(ShowLogDialogComponent, { initialState })
    //this._dialogService.addDialog(ShowLogDialogComponent, { source: "training", username: this.sectormodel.User }).subscribe(data => console.log(data))
  }

}
